import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import CustomizerContext from '../../_helper/Customizer';
import City2CityIcon from '../../assets/images/logo512.png';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      <Link to={`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`}>
        <img
          className="img-fluid"
          src={City2CityIcon}
          alt=""
          style={{ width: "40px" }}
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;